import { Injectable } from '@angular/core';
import { INDDReportAccessTokenProvider } from '@ndk/ng-reports/config';
import { LocalStorageService } from '@ndk/ng-storage';

import { LocalStorageKeys } from '../storage/local-storage.enum';

@Injectable()
export class ReportAccessTokenService implements INDDReportAccessTokenProvider {
    constructor(private localStorage: LocalStorageService) { }

    public getAccessToken(): string { // TODO: criar testes de unidade
        return this.localStorage.getValue(LocalStorageKeys.Token);
    }
}
